import { createThunkWithError } from "../featureHelpers/errorParser";
import companionService from "./companion.service";

// get API integrations
export const dictateTasks = createThunkWithError<string[], File>(
  "companion/dictate-tasks",
  async (file) => companionService.dictateTasks(file),
);
